<template>
  <div class="order-payment-successded-modular">
    <div class="order-payment-successded-body-modular">
      <div class="payment-successded-header-modular">
        <div class="payment-successded-header">
          <div class="logo-modular">
            <img class="logo-img" src="../assets/public/logo.png" alt="" @click="toHome"/>
          </div>
          <div class="steps-modular">
            <el-steps :active="active" align-center>
              <el-step :title="pageTextArr[0]"></el-step>
              <el-step :title="pageTextArr[1]"></el-step>
              <el-step :title="pageTextArr[2]"></el-step>
            </el-steps>
          </div>
        </div>
      </div>
      <div class="payment-successded-body-modualr">
        <div class="payment-successded-img-modualr">
          <img
            class="successded-icon"
            src="../assets/public/successded-icon.png"
            alt=""
          />
        </div>
        <div class="payment-successded-title-modualr">
          <p class="successded-title">{{ pageTextArr[3] }}</p>
          <p class="successded-title">{{ pageTextArr[4] }}</p>
        </div>
        <div class="other-operation">
          <div class="other-operation-item" @click="toOrderDetail()">
            {{pageTextArr[5]}}
          </div>
          <div class="other-operation-line"></div>
          <div class="other-operation-item" @click="toHome()">{{ pageTextArr[6] }}</div>
        </div>
      </div>
      <div class="guess-like-modular">
        <div class="guess-like-title">{{ pageTextArr[7] }}</div>
        <div class="commodity-recommend-modular">
          <div class="commodity-show-modular">
            <div
              class="commodity-show-item-modualr"
              v-for="(item, index) in hotSaleProductData"
              :key="index"
            >
              <div class="commodity-show-item">
                <div class="commodity-show-item-img">
                  <img class="commodity-show-img" :src="item.cover" alt=""  @click="toProductDetail(item.id)"/>
                </div>
                <div class="commodity-show-item-msg">
                  <div class="commodity-show-item-price">
                    {{ currencySymbol
                    }}{{
                      item.has_discount == 1 ? item.discount_price : item.price
                    }}
                    <span
                      class="commodity-show-item-discpunt-price"
                      v-if="item.has_discount == 1"
                    >
                      {{ currencySymbol }}{{ item.price }}
                    </span>
                  </div>
                  <div class="commodity-show-item-introduce">
                    {{ currLanguage == 3 ? item.eng_title : item.title }}
                  </div>
                  <div class="commodity-show-item-evaluate">
                    <div class="commodity-evaluate">
                      <span class="commodity-evaluate-num">{{
                        item.comment_num
                      }}</span>
                      <span class="commodity-evaluate-title">{{
                        pageTextArr[8]
                      }}</span>
                    </div>
                    <div class="commodity-coupon" v-if="item.has_coupon == 1">
                      {{ pageTextArr[9] }}
                    </div>
                  </div>
                  <!-- <div class="commodity-show-item-operation">
                    <div class="commodity-collection">
                      <img class="collection-icon" src="../assets/home/collection-icon.png" alt="">
                      <span class="collection-title">收藏</span>
                    </div>
                    <div class="commodity-shop-cart">
                      <img class="shop-cart-icon" src="../assets/home/shop-cart-icon.png" alt="">
                      <span class="add-cart-title">加入购物车</span>

                    </div>
                  </div> -->
                  <div class="commodity-show-item-operation">
                  <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                    <span
                      class="add-cart-title"
                      >{{ pageTextArr[10] }}</span
                    >
                  </div>
                </div>
                  <div class="commodity-show-item-operation">
                    <!-- <div
                      class="commodity-collection"
                      @click="
                        productaddCollect(item.id, item.is_collect, index, 2)
                      "
                    >
                      <img
                        class="collection-icon"
                        v-if="item.is_collect == 1"
                        src="../assets/home/collection-icon-2.png"
                        alt=""
                      />
                      <img
                        class="collection-icon"
                        v-else
                        src="../assets/home/collection-icon.png"
                        alt=""
                      />
                      <span class="collection-title">{{
                        $t("translateText.collectText")
                      }}</span>
                    </div> -->
                    <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                      <!-- <img
                        class="shop-cart-icon"
                        src="../assets/home/shop-cart-icon.png"
                        alt=""
                      /> -->
                      <span
                        class="add-cart-title"
                        >{{ pageTextArr[11] }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 2,
      order_number: "", //order_number
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),

      hotSaleProductData: [], //猜我喜欢
      currLanguage: 1, //当前语言
      pageTextArr:[
        "确认订单",
        "付款",
        "支付成功",
        "您已成功付款",
        "我们尽快为您处理",
        "订单详情",
        "继续逛逛",
        "猜你喜欢",
        "评价",
        "优惠券",
        "产品细节",
        "加入购物车",
      ]
    };
  },
  methods: {
    /**
     * 订单详情
     * @param {*} order_number
     */
    toOrderDetail() {
      this.$router.push({
        path: "/waitingPayment",
        query: { order_number: this.order_number, page_status: 1 },
      });
    },

    /**
     * 返回首页
     */
    toHome() {
      this.$router.push({
        path: "/",
        // query: { order_id: id }
      });
    },
    /**
     *  商品列表
     * @param {*} id
     */
    getProductSignList(id) {
      let that = this;
      let data = {
        id: id,
        type_id: 0,
        page: 1,
        pagesize: 5,
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getProductSignList(
        data,
        (res) => {
          if (res.ret == 1) {
            //  商品数据赋值
            // that.setProductById(id, res.data);
            that.hotSaleProductData = res.data;
            that.languageTranslateByArrs(that.hotSaleProductData,2)
          } else {
            // this.$message.error(res.msg);
            // 清空 - 热销产品
            that.hotSaleProductData = [];
          }
        },
        (res) => {
          // 清空 - 热销产品
          that.hotSaleProductData = [];
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 跳转商品详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     *  加入收藏 取消收藏
     * @param {*} id
     * @param {*} status
     * @param {*} index
     * @param {*} flag
     */
    productaddCollect(id, status, index, flag) {
      let that = this;
      let newData;
      that.$parent.productCollect(
        id,
        status,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 设置当前list表的收藏状态
            // that.setProductCollectById(status, index, flag);
            newData = that.hotSaleProductData[index];
            newData.is_collect = !status;
            this.$set(that.recommendProductData, index, newData);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr,type){
      let that = this
      let newpagetextArr = []
      if(type==1){
        that.translateByArr(arr,res=>{
        console.log("res",res);
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
      }else if(type==2){
        let newArr=[];
        arr.forEach((item,index)=>{
            newArr.push(item.title);
        })
        that.translateByArr(newArr,res=>{
        res.data.forEach((items,indexs)=>{
          that.hotSaleProductData[indexs].title=items.translation
        })
      })
      }else{
        let newarr=[];
        let skuarr=[];
        arr.forEach((item,index)=>{
          newarr.push(item.title)
          skuarr.push(item.specifications)
        })
        that.translateByArr(newarr,res=>{
          res.data.forEach((item,index)=>{
          that.confirmProductInformation[0].product_data[index].title=item.translation
          })
        })
        that.translateByArr(skuarr,res=>{
          res.data.forEach((item,index)=>{
          that.confirmProductInformation[0].product_data[index].specifications=item.translation
          })
        })
      }
    }
  },
  mounted() {
    let that = this;
    //订单id
    that.order_number = that.$route.query.order_number;
    this.getProductSignList(3);
    that.languageTranslateByArrs(that.pageTextArr,1)

  },
};
</script>


// WEBPACK FOOTER //
// src/view/orderPaymentSucceeded.vue